import { useMutation } from "react-query";
import { removeFromEnvelopSigners } from "../api/signatureqc";

export const useRemoveFromEnvelopSigners = (options = {}) =>
  useMutation(removeFromEnvelopSigners, options);

export default { useRemoveFromEnvelopSigners };
